var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0.865234","y1":"0.539062","x2":"17","y2":"0.539062","stroke":"white","key":0}),React.createElement("line",{"x1":"0.865234","y1":"6.10547","x2":"17","y2":"6.10547","stroke":"white","key":1}),React.createElement("line",{"x1":"0.865234","y1":"11.6719","x2":"17","y2":"11.6719","stroke":"white","key":2})]);
}

Burger.defaultProps = {"width":"17","height":"13","viewBox":"0 0 17 13","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
